module.exports = __webpack_public_path__ + "img/compress-icon.52e06f67.svg";